module.exports = __webpack_public_path__ + "static/Toni&Andi-9-dcb2c75c5b91539ba330af51cb9cfd35.jpg";